<template>
    <div :class="inputContainerClass">
         <v-text-field
            v-model="content"
            @input="handleInput"
            :max="max"
            :min="min"
          ></v-text-field>
    </div>
</template>
<script>
import Commons from "./Commons.vue";
export default {
    extends: Commons,
    props: {
        'min': {
            type: Number,
            default: 0,
        },
        'max': {
            type: Number,
            default: 10,
        },
    },
};
</script>
<style lang="scss">
</style>
